import { ReportViewerPopupComponent } from './popup.component';
import { ReportViewerComponent } from './reportviewer.component';
import { BarcodeReportViewerComponent } from '../barcode-report-viewer/barcode-report-viewer.componant';
import { QrReportViewerComponent } from '../qr-report-viewer/qr-report-viewer.component';

export const VIEWER_DECLERATION: any[] = [
  ReportViewerComponent,
  ReportViewerPopupComponent,
  BarcodeReportViewerComponent,
  QrReportViewerComponent
]


